module.exports = __webpack_public_path__ + "configuration/config_local.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=configuration/config_local.json!./src/config/config_local.json
// module id = 539
// module chunks = 3